import React, { useState, useEffect, useRef } from "react";
import { MdKeyboard } from "react-icons/md";
import axios from 'axios';
import useAuth from '../../Users/hooks/useAuth';
import PacmanLoader from "react-spinners/PacmanLoader";
import { BsArrowsCollapse, BsArrowsExpand } from "react-icons/bs";

import NarratorIntonation from './NarratorIntonation';
import IntonationFeedbackDisplay from './IntonationFeedbackDisplay';
import AIAssessmentDisplay from './AIAssessmentDisplay';
import SegmentEditor from './SegmentEditor';

// Import UI Components
import { KeyboardHelpModal } from './components/KeyboardHelpModal';
import { MobileHeader } from './components/MobileHeader';

import ProgressPill from './ProgressPill';

import ProgressModal from "./ProgressModal";

import ExerciseHelpModal from './ExerciseHelpModal';
import { loadCourse } from './guidelines/loadCourse';

console.log("API URL =", process.env.REACT_APP_USER_API_URL);

// Custom hook for mobile detection
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(window.innerWidth < 1280);
        };
        
        checkDevice();
        window.addEventListener('resize', checkDevice);
        
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []);

    return isMobile;
};

// Shadowing timing configuration



const SHADOWING_TIMING = {
  CUE_TOTAL_DURATION: 2200,
  PULSE_1_TIME: 200,
  PULSE_2_TIME: 800,
  PULSE_3_TIME: 1600,
  CUE_CLEAR_TIME: 600,
  RECORDING_START_OFFSET: -100,
  AUDIO_START_DELAY: 2200,
  POST_AUDIO_BUFFER: 200,
};

// Echoing timing configuration - SHORTER like shadowing
const ECHOING_TIMING = {
  PULSE_1_TIME: 200,
  PULSE_2_TIME: 500,
  PULSE_3_TIME: 900,
  CUE_CLEAR_TIME: 200,
  TOTAL_DURATION: 1100,
};

const SnapsWise = ({subject, file})=>{
    console.log(subject, file, "subjectfile")
    // ============================================
    // SECTION 1: STATE MANAGEMENT
    // ============================================
    const [modelSize, setModelSize] = useState("turbo");
    const [rate, setRate] = useState(1);
    const [loading, setLoading] = useState(false);
    const mimeType = "audio/webm";
    const [segment, setSegment] = useState({});
    const [editedSegments, setEditedSegments] = useState();
    const [editedSegment, setEditedSegment] = useState();
    const [isgranted, setIsGranted] = useState(false);
    const [stream, setStream] = useState();
    const [audio, setAudio] = useState(null);
    const [hasRecording, setHasRecording] = useState(false);
    const [assessment, setAssessment] = useState(null);
    const { auth, setAuth } = useAuth();
    const isGuest = auth?.username === "guest";
    const [segments, setSegments] = useState();
    const [broadcastTime, setBroadcastTime] = useState(0);
    
    const [state, setState] = useState({});
    const [focus, setFocus] = useState({});
    const [focused, setEdFocus] = useState();
    
    const [collapse, setCollapse] = useState(false);
    const [translation, setTranslation] = useState();
    
    // State for visualization and layout
    const [showIntonationVisualization, setShowIntonationVisualization] = useState(true);
    const [visualizationView, setVisualizationView] = useState('pitch');
    const [activeTab, setActiveTab] = useState('sentence');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showKeyboardHelp, setShowKeyboardHelp] = useState(false);
    
    // New state for translation modal
    const [showTranslationModal, setShowTranslationModal] = useState(false);
    
    // Practice mode states
    const [practiceMode, setPracticeMode] = useState('echoing');
    const [preservedMode, setPreservedMode] = useState('echoing');
    
    // Echoing mode states
    const [echoingPhase, setEchoingPhase] = useState('idle');
    const [echoingTimeout, setEchoingTimeout] = useState(null);
    const [echoingPulseCount, setEchoingPulseCount] = useState(0);
    const [echoingTimeouts, setEchoingTimeouts] = useState([]);
    const echoingPhaseRef = useRef('idle');
    
    // Shadowing mode states
    const [isShadowing, setIsShadowing] = useState(false);
    const [shadowingTimeout, setShadowingTimeout] = useState(null);
    const [showFirstWordCue, setShowFirstWordCue] = useState(false);
    const [cuePulseCount, setCuePulseCount] = useState(0);
    const [isCueActive, setIsCueActive] = useState(false);
    const [cueTimeouts, setCueTimeouts] = useState([]);
    
    // Recording states
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [audioChunks, setAudioChunks] = useState([]);
    const [duration, setDuration] = useState(6);
    const [isPlayingSegment, setIsPlayingSegment] = useState(false);
    const [currentWord, setCurrentWord] = useState(0);
    const [recordingProgress, setRecordingProgress] = useState(0);
    const [maxRecordingTime, setMaxRecordingTime] = useState(0);

   
    const STEP_SECONDS = 1 * 60;
    const MIN_GOAL_SECONDS = 1 * 60; // change later if you want
    const [todaySeconds, setTodaySeconds] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [goalSeconds, setGoalSeconds] = useState(5 * 60);

    const [wordMenu, setWordMenu] = useState(null);

    const [course, setCourse] = useState(null);
    const [showExerciseHelp, setShowExerciseHelp] = useState(false);

    const deriveExerciseId = (subject, file) => {
  const key = subject?.course_key;
  const name = file?.file;
  if (!key || !name) return null;

  // ✅ Flyt og rytme naming scheme ONLY
  if (key === "flyt-og-rytme") {
    // Matches: 01a_nodoubles.mp3, 01A.mp3, 2b-something.mp3
    const m = String(name).match(/^(\d{1,2})\s*([abAB])(?=[._-]|$)/);
    if (!m) return null;
    return `${parseInt(m[1], 10)}${m[2].toUpperCase()}`;
  }

  // ✅ Other courses later:
  // if (key === "other-course") { ... }

  return null;
};



    const openWordMenu = (e, text, i) => {
  e.preventDefault();
  e.stopPropagation();
  const r = e.currentTarget.getBoundingClientRect();
  setWordMenu({ text, i, rect: { left: r.left, top: r.top, width: r.width, height: r.height } });
};

const closeWordMenu = () => setWordMenu(null);

const handleAuthExpired = () => {
  if (isGuest) return;
  localStorage.removeItem("token");
  window.location.assign("/");
};

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (isGuest) return {};
  if (!token) {
    handleAuthExpired();
    return {};
  }
  return { Authorization: `Bearer ${token}` };
};



const fetchDailyGoal = async (language) => {
  if (!language) return;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/goals/daily?language=${encodeURIComponent(language)}`,
      { headers: authHeaders() }
    );

    if (res.status === 401 || res.status === 403) return handleAuthExpired();
    if (!res.ok) return;

    const json = await res.json();
    const n = Number(json.goal_seconds);
    setGoalSeconds(Number.isFinite(n) ? n : MIN_GOAL_SECONDS);
  } catch (e) {
    console.error("fetchDailyGoal error:", e);
  }
};


const clampGoal = (s) => Math.min(6 * 60 * 60, Math.max(MIN_GOAL_SECONDS, s));

const updateDailyGoal = async (nextGoalSeconds) => {
  const language = subject?.language;
  if (!language) return;

  const next = clampGoal(nextGoalSeconds);
  

  try {
    const url =
      `${process.env.REACT_APP_USER_API_URL}/goals/daily` +
      `?language=${encodeURIComponent(language)}` +
      `&goal_seconds=${next}`;
  
    const res = await fetch(url, {
      method: "PUT",
      headers: authHeaders(),
    });
    
    if (!res.ok) {
      console.warn("updateDailyGoal failed:", res.status);
      return;
    }

    const json = await res.json();
   

    const n = Number(json.goal_seconds);
    setGoalSeconds(Number.isFinite(n) ? n : next);
  } catch (e) {
    console.error("updateDailyGoal error:", e);
  }
};



 const fetchTodayActivity = async (language) => {
  if (!language) return;
  if (isGuest) return; // <-- guests: do nothing

  try {
    const res = await fetch(
      `${process.env.REACT_APP_USER_API_URL}/activity/today?language=${encodeURIComponent(language)}`,
      { headers: authHeaders() }  // <-- reuse your helper
    );

    if (res.status === 401 || res.status === 403) return handleAuthExpired();
    if (!res.ok) return;

    const json = await res.json();
    setTodaySeconds(json.done_seconds ?? 0);
  } catch (e) {
    console.error("fetchTodayActivity error:", e);
  }
};


    


    // ============================================
    // SECTION 2: REFS
    // ============================================
    const audioRecordRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const keyboardListenerRef = useRef(null);
    const mediaRecorder = useRef(null);
    const audioref = useRef(null);
    const recordRef = useRef(null);
    const pulseRef = useRef(null);
    const currentHandlerRef = useRef(null);
    const currentHandlerRefEd = useRef(null);

    const isMobile = useIsMobile();

    const audioRecord = useRef(null);
    const fullaudio = `${process.env.REACT_APP_USER_API_URL}/`+file.full_path;

    // ============================================
    // SECTION 3: UTILITY FUNCTIONS
    // ============================================
    const pulse_frames = [ 
        { transform: "scale(1)", opacity: "1" },
        { transform: "scale(1.1)", opacity: "0.8" },
        { transform: "scale(1)", opacity: "1" },
    ];

    const progress_frames = [ 
        { transform: "translateX(0)" },
        { transform: "translateX(176px)" },
        { transform: "translateX(0)" },
    ];

    // ============================================
    // SECTION 4: CORE FUNCTIONS
    // ============================================
    
    const timeUpdate = (event) => {
        const currentTime = event.target.currentTime;
        setBroadcastTime(currentTime-segment.start);
        
        if (segment.hasOwnProperty("words")) {
            const foundword = segment.words.findIndex((word) => 
                word.start <= currentTime && word.end > currentTime
            );
            if (foundword !== -1 && currentWord !== foundword) {
                setCurrentWord(foundword);
            }
        }
        
        if (!isPlayingSegment) {
            var found = segments?.find((segment) => segment.end > currentTime);
            var founded = null;
            if (editedSegments) {
                founded = editedSegments.find((segment) => segment.end > currentTime);
            }
            if (founded) {
                if (editedSegment !== founded) {
                    setEditedSegment(founded);
                }
            }
            if (found) {
                if (segment !== found) {
                    
                    setSegment(found);
                    setCurrentWord(0);
                }
            }
        }
    };
   
  const sendBlob = ({ blob, subject, file, segment }) => {
  const token = localStorage.getItem("token");

  const url = `${process.env.REACT_APP_USER_API_URL}/analysis/upload_blob/${subject.owner}/${subject.language}/${subject.author}/${subject.title}/${file.file}/${subject.type}`;

  const formData = new FormData();
  formData.append("uploaded_file", blob);
  formData.append("sendText", JSON.stringify(segment));
  formData.append("tz", Intl.DateTimeFormat().resolvedOptions().timeZone);

  // ✅ Guest: no auth header
  // ✅ Logged-in: attach token
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  axios
    .post(url, formData, { headers })
    .then((response) => {
      setAssessment(response.data);
      setLoading(false);

      // ✅ Progress tracking only for non-guest (you said: don't show progressbar to guests)
      if (!isGuest) {
        const act = response?.data?.activity;
        if (act && typeof act.daily_total_seconds === "number") {
          setTodaySeconds(act.daily_total_seconds);
        } else {
          fetchTodayActivity(subject.language);
        }
      }
    })
    .catch((error) => {
      const status = error?.response?.status;
      console.error("Error uploading file:", status, error);

      // ✅ stop spinner
      setLoading(false);

      // ✅ Only redirect real users on auth failures
      if (!isGuest && (status === 401 || status === 403)) {
        handleAuthExpired();
      }

      // Optional: show a friendly message for guests
      // if (isGuest) alert("Guest mode: upload failed. Please try again.");
    });
};



    const getTranslations = async (info) => {
        const token = localStorage.getItem("token");
                  
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/dictionary/get-translation`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(info),
        });
        
        if (response.ok) {
            const json = await response.json();
            setTranslation(json);
        }
    };

    const getSegments = async ({subject, file}) => {
        const token = localStorage.getItem("token");
        const outdata = {
            "author": subject.author, 
            'title': subject.title, 
            'language': subject.language, 
            'file': file, 
            "type": subject.type
        };          
        
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/whisper/get-segments`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(outdata),
        });
        
        if (response.ok) {
            const json = await response.json();
            setSegments(json.segments);
            if (json.model_size) {
                setModelSize(json.model_size);
                
            }
        }
    };

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setIsGranted(true);
                setStream(streamData);
            } catch (err) {
                console.error("Error getting microphone permission:", err);
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    // ============================================
    // SECTION 5: AUDIO PLAYBACK FUNCTIONS
    // ============================================
    
    const Play_record = () => {
  setTimeout(() => {
    if (!audioRecord.current) return;
    audioRecord.current.currentTime = 0;
    audioRecord.current.play();
  }, 300);
};
    const newreachedEnd = (segment) => {
        const handler = (event) => {
            const currentTime = event.target.currentTime;
            
            if (currentTime >= segment.end - 0.001) {
                audioref.current.pause();
                audioref.current.currentTime = segment.start;
                audioref.current.removeEventListener('timeupdate', handler);
                currentHandlerRef.current = null;
                setIsPlayingSegment(false);
                setCurrentWord(0);
                
                if (isShadowing && recordingStatus === "recording") {
                    setTimeout(() => {
                        if (shadowingTimeout) {
                            clearTimeout(shadowingTimeout);
                            setShadowingTimeout(null);
                        }
                        stopShadowingRecording(true);
                    }, 500);
                }
                
                // Check echoing phase from ref (synchronous)
                if (practiceMode === 'echoing' && echoingPhaseRef.current === 'playing') {
                    startEchoingCountdown();
                }
            }
        };
        return handler;
    };

    const newreachedEndEd = (segment) => {
        const handlered = (event) => {
            if (event.target.currentTime >= segment.end) {
                audioref.current.pause();
                setEdFocus(focused);
                audioref.current.currentTime = segment.start;
                audioref.current.removeEventListener('timeupdate', handlered);
                currentHandlerRefEd.current = null;
            }
        };
        return handlered;
    };

    const handler = newreachedEnd(segment);
    const handlered = newreachedEndEd(editedSegment);

    // ============================================
    // SECTION 6: RECORDING FUNCTIONS
    // ============================================
    
    const startRecording = async (sendForAnalysis = true) => {
        setRecordingStatus("recording");
        setRecordingProgress(0);
        
        const maxTime = 3 * duration * 1000;
        setMaxRecordingTime(maxTime);
        
        const media = new MediaRecorder(stream, { type: mimeType });
        mediaRecorder.current = media;
        mediaRecorderRef.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
        
        // Start progress tracking for manual mode
        const startTime = Date.now();
        const updateProgress = () => {
            if (recordingStatus === "recording") {
                const elapsed = Date.now() - startTime;
                const progress = Math.min((elapsed / maxTime) * 100, 100);
                setRecordingProgress(progress);
                
                if (progress < 100) {
                    requestAnimationFrame(updateProgress);
                }
            }
        };
        
        requestAnimationFrame(updateProgress);
    };

    const stopRecording = (sendForAnalysis = true) => {
        if (sendForAnalysis) {
            setAssessment(null);
            setLoading(true);
        }
        
        setRecordingProgress(sendForAnalysis ? 100 : 0);
        
        if (recordRef.current) {
            recordRef.current.getAnimations().forEach(function (arrayItem) {
                arrayItem.pause();
            });
        }
      
        setRecordingStatus("inactive");
        setHasRecording(sendForAnalysis);
        
        mediaRecorder.current.stop();
        
        mediaRecorder.current.onstop = () => {
            if (sendForAnalysis) {
                const audioBlob = new Blob(audioChunks, { type: mimeType });
                const audioUrl = URL.createObjectURL(audioBlob);
                sendBlob({"blob": audioBlob, "subject": subject, "file": file, "segment": segment});
                setAudio(audioUrl);
            }
            setAudioChunks([]);
        };
    };

    // ============================================
    // SECTION 6.5: PROCESS CANCELLATION FUNCTIONS
    // ============================================
    
    const silentCancelRecording = () => {
        setRecordingStatus("inactive");
        setRecordingProgress(0);
        setIsShadowing(false);
        setIsCueActive(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        
        if (shadowingTimeout) clearTimeout(shadowingTimeout);
        if (echoingTimeout) clearTimeout(echoingTimeout);
        setShadowingTimeout(null);
        setEchoingTimeout(null);
        
        // Clear all echoing timeouts
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
            try {
                mediaRecorder.current.onstop = null;
                mediaRecorder.current.stop();
            } catch (error) {
                console.error("Error stopping recorder:", error);
            }
        }
        
        setAudioChunks([]);
        
        [recordRef.current, pulseRef.current].forEach(ref => {
            if (ref) {
                const animations = ref.getAnimations();
                if (animations) {
                    animations.forEach(animation => animation.cancel());
                }
            }
        });
    };

    const cancelAllProcesses = () => {
        if (recordingStatus === 'recording') {
            silentCancelRecording();
        }
        
        if (audioref.current) {
            audioref.current.pause();
            setIsPlayingSegment(false);
            
            if (currentHandlerRef.current) {
                audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
                currentHandlerRef.current = null;
            }
        }
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setIsCueActive(false);
    };

    // ============================================
    // SECTION 6.6: SHADOWING FUNCTIONS
    // ============================================
    
    const triggerFirstWordCue = () => {
        if (!segment || !segment.words || segment.words.length === 0) {
            console.error("Cannot trigger cue: segment or words missing");
            return;
        }
        
        setIsCueActive(true);
        setCuePulseCount(0);
        setShowFirstWordCue(true);
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        const newTimeouts = [];
        
        const timeout1 = setTimeout(() => {
            setCuePulseCount(1);
        }, SHADOWING_TIMING.PULSE_1_TIME);
        newTimeouts.push(timeout1);
        
        const timeout2 = setTimeout(() => {
            setCuePulseCount(2);
        }, SHADOWING_TIMING.PULSE_2_TIME);
        newTimeouts.push(timeout2);
        
        const timeout3 = setTimeout(() => {
            setCuePulseCount(3);
            
            const clearTimeoutId = setTimeout(() => {
                setIsCueActive(false);
                setShowFirstWordCue(false);
                setCuePulseCount(0);
            }, SHADOWING_TIMING.CUE_CLEAR_TIME);
            newTimeouts.push(clearTimeoutId);
        }, SHADOWING_TIMING.PULSE_3_TIME);
        newTimeouts.push(timeout3);
        
        setCueTimeouts(prev => [...prev, ...newTimeouts]);
        
        const recordingStartTime = SHADOWING_TIMING.AUDIO_START_DELAY + SHADOWING_TIMING.RECORDING_START_OFFSET;
        
        return recordingStartTime;
    };

    const startShadowing = () => {
        if (!stream || !segment) {
            console.error("Cannot start shadowing: stream or segment missing");
            return;
        }
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        let recordingStartTime = 0;
        if (segment && segment.words && segment.words.length > 0) {
            recordingStartTime = triggerFirstWordCue();
        }
        
        setIsShadowing(true);
        
        const recordingTimeout = setTimeout(() => {
            setRecordingStatus("recording");
            
            try {
                const media = new MediaRecorder(stream, { type: mimeType });
                mediaRecorder.current = media;
                mediaRecorderRef.current = media;
                mediaRecorder.current.start();
                let localAudioChunks = [];
                
                mediaRecorder.current.ondataavailable = (event) => {
                    if (typeof event.data === "undefined") return;
                    if (event.data.size === 0) return;
                    localAudioChunks.push(event.data);
                };
                setAudioChunks(localAudioChunks);
                
                const audioDelay = SHADOWING_TIMING.AUDIO_START_DELAY - recordingStartTime;
                const playTimeout = setTimeout(() => {
                    if (audioref.current && segment && segment.start !== undefined) {
                        setFocus(segment);
                        audioref.current.currentTime = segment.start;
                        audioref.current.play();
                        
                        if (currentHandlerRef.current) {
                            audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
                        }
                        currentHandlerRef.current = handler;
                        audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
                        setIsPlayingSegment(true);
                        
                        if (segment.start !== undefined && segment.end !== undefined) {
                            const segmentDuration = (segment.end - segment.start) * 1000;
                            const totalDuration = segmentDuration + SHADOWING_TIMING.POST_AUDIO_BUFFER;
                            
                            const stopTimeout = setTimeout(() => {
                                if (recordingStatus === "recording") {
                                    stopShadowingRecording(true);
                                }
                            }, totalDuration);
                            
                            setShadowingTimeout(stopTimeout);
                        }
                    }
                }, Math.max(0, audioDelay));
                
                setCueTimeouts(prev => [...prev, playTimeout]);
            } catch (error) {
                console.error("Error starting shadowing:", error);
                setIsShadowing(false);
                setRecordingStatus("inactive");
            }
        }, Math.max(0, recordingStartTime));
        
        setCueTimeouts(prev => [...prev, recordingTimeout]);
    };

    const stopShadowingRecording = (sendForAnalysis = true) => {
        if (sendForAnalysis) {
            setAssessment(null);
            setLoading(true);
        }
        
        setRecordingProgress(0);
        
        if (recordRef.current) {
            const animations = recordRef.current.getAnimations();
            if (animations) {
                animations.forEach(function (arrayItem) {
                    if (arrayItem && typeof arrayItem.pause === 'function') {
                        arrayItem.pause();
                    }
                });
            }
        }
        
        setRecordingStatus("inactive");
        setIsShadowing(false);
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        setIsCueActive(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        
        if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
            try {
                mediaRecorder.current.stop();
                
                mediaRecorder.current.onstop = () => {
                    if (sendForAnalysis && audioChunks && audioChunks.length > 0) {
                        const audioBlob = new Blob(audioChunks, { type: mimeType });
                        const audioUrl = URL.createObjectURL(audioBlob);
                        sendBlob({"blob": audioBlob, "subject": subject, "file": file, "segment": segment});
                        setAudio(audioUrl);
                        setHasRecording(true);
                        setAudioChunks([]);
                    } else {
                        setAudioChunks([]);
                    }
                    setIsShadowing(false);
                };
            } catch (error) {
                console.error("Error stopping shadow recording:", error);
                setIsShadowing(false);
            }
        } else {
            setIsShadowing(false);
        }
    };

    // ============================================
    // SECTION 6.7: ECHOING MODE FUNCTIONS - FIXED WITH SHORTER TIMING
    // ============================================
    
    const startEchoingMode = async () => {
        if (!isgranted) {
            await getMicrophonePermission();
            if (!isgranted) return;
        }
        
        cancelAllProcesses();
        
        // Phase 1: Play the segment
        setEchoingPhase('playing');
        echoingPhaseRef.current = 'playing';
        
        if (audioref.current && segment && segment.hasOwnProperty("start")) {
            setFocus(segment);
            audioref.current.currentTime = segment.start;
            audioref.current.play();
            
            if (currentHandlerRef.current) {
                audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
            }
            currentHandlerRef.current = handler;
            audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
            setIsPlayingSegment(true);
        }
    };

    const startEchoingCountdown = () => {
        setEchoingPhase('paused');
        echoingPhaseRef.current = 'paused';
        setEchoingPulseCount(0);
        
        // Clear any existing timeouts
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        const newTimeouts = [];
        
        // Pulse 1 - 200ms
        const timeout1 = setTimeout(() => {
            setEchoingPulseCount(1);
        }, ECHOING_TIMING.PULSE_1_TIME);
        newTimeouts.push(timeout1);
        
        // Pulse 2 - 800ms
        const timeout2 = setTimeout(() => {
            setEchoingPulseCount(2);
        }, ECHOING_TIMING.PULSE_2_TIME);
        newTimeouts.push(timeout2);
        
        // Pulse 3 - 1600ms and start recording
        const timeout3 = setTimeout(() => {
            setEchoingPulseCount(3);
            
            // Clear the cue after 600ms (same as shadowing)
            const clearTimeoutId = setTimeout(() => {
                setEchoingPhase('recording');
                echoingPhaseRef.current = 'recording';
                startEchoingRecording();
            }, ECHOING_TIMING.CUE_CLEAR_TIME);
            newTimeouts.push(clearTimeoutId);
        }, ECHOING_TIMING.PULSE_3_TIME);
        newTimeouts.push(timeout3);
        
        setEchoingTimeouts(prev => [...prev, ...newTimeouts]);
    };

    const startEchoingRecording = () => {
        setRecordingStatus("recording");
        setRecordingProgress(0);
        
        const maxTime = 3 * duration * 1000;
        setMaxRecordingTime(maxTime);
        
        const media = new MediaRecorder(stream, { type: mimeType });
        mediaRecorder.current = media;
        mediaRecorderRef.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
        
        // Start progress tracking
        const startTime = Date.now();
        const updateProgress = () => {
            if (recordingStatus === "recording" && echoingPhase === 'recording') {
                const elapsed = Date.now() - startTime;
                const progress = Math.min((elapsed / maxTime) * 100, 100);
                setRecordingProgress(progress);
                
                if (progress < 100) {
                    requestAnimationFrame(updateProgress);
                }
            }
        };
        
        requestAnimationFrame(updateProgress);
        
        const stopTimeout = setTimeout(() => {
            if (recordingStatus === "recording" && echoingPhase === 'recording') {
                stopEchoingRecording(true);
            }
        }, maxTime);
        
        setEchoingTimeout(stopTimeout);
    };

    const stopEchoingRecording = (sendForAnalysis = true) => {
        if (sendForAnalysis) {
            setAssessment(null);
            setLoading(true);
        }
        
        setRecordingProgress(sendForAnalysis ? 100 : 0);
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        setRecordingStatus("inactive");
        
        if (mediaRecorder.current && mediaRecorder.current.state !== "inactive") {
            try {
                mediaRecorder.current.stop();
                
                mediaRecorder.current.onstop = () => {
                    if (sendForAnalysis) {
                        const audioBlob = new Blob(audioChunks, { type: mimeType });
                        const audioUrl = URL.createObjectURL(audioBlob);
                        sendBlob({"blob": audioBlob, "subject": subject, "file": file, "segment": segment});
                        setAudio(audioUrl);
                        setHasRecording(true);
                    }
                    setAudioChunks([]);
                };
            } catch (error) {
                console.error("Error stopping echo recording:", error);
            }
        }
    };

    const cancelEchoingMode = () => {
        cancelAllProcesses();
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
    };

    // ============================================
    // SECTION 7: UI HANDLER FUNCTIONS
    // ============================================
    
    const handleWordClick = (word) => {
        if (!word || !subject || !subject.language) return;
        
        getTranslations({"word": word, "tolanguage": "English", "fromlanguage": subject.language});
        
        if (isMobile) {
            setShowTranslationModal(true);
        }
    };

    const handleSaveEditedSegments = async (editedSegmentsToSave) => {
        const token = localStorage.getItem("token");
        const requestData = {
            author: subject.author,
            title: subject.title,
            language: subject.language,
            type: subject.type,
            owner: subject.owner,
            file: file.file,
            size_of_model: modelSize
        };

       

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_USER_API_URL}/whisper/add-edited-segments`,
                {
                    fileinfo: requestData,
                    segments: editedSegmentsToSave
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.data.status === "success") {
                alert(`Edited segments ${response.data.action} successfully!`);
                setEditedSegments(null);
                setEditedSegment(null);
                return true;
            } else {
                throw new Error("Failed to save edited segments");
            }
        } catch (error) {
            console.error("Error saving edited segments:", error);
            alert("Error saving edited segments. Please try again.");
            throw error;
        }
    };

    const handlePreviousSegment = () => {
        if (segment && segment["id"] !== 0 && segments) {
            cancelAllProcesses();
            
            setAssessment(null);
            setLoading(false);
            setTranslation();
            
            if (audioref.current) {
                audioref.current.currentTime = segments[segment["id"] - 1]["start"];
            }
            setSegment(segments[segment["id"] - 1]);
            setCurrentWord(0);
        }
    };

    const handleNextSegment = () => {
        if (segment && segment["id"] <= segments.length - 2 && segments) {
            cancelAllProcesses();
            
            setAssessment(null);
            setLoading(false);
            setTranslation();
            
            if (audioref.current) {
                audioref.current.currentTime = segments[segment["id"] + 1]["start"] + 0.01;
            }
            setSegment(segments[segment["id"] + 1]);
            setCurrentWord(0);
        }
    };

    const handlePlaySentence = () => {
        cancelAllProcesses();
        setFocus(segment);
        if (audioref.current && segment && segment.hasOwnProperty("start")) {
            if (audioref.current.paused) {
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
            } else {
                audioref.current.pause();
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
            }

            if (currentHandlerRef.current) {
                audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
            }
            currentHandlerRef.current = handler;
            audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
            setIsPlayingSegment(true);
        }
    };

    const handleWordPlay = (i, item) => {
        setFocus(segment);
        if (audioref.current) {   
            if (currentHandlerRef.current) {
                audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
            }
            currentHandlerRef.current = handler;
            audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
            setIsPlayingSegment(true);
            
            const startTime = (i !== 0) ? segment.words[i-1].start : item.start;
            
            if (audioref.current.paused) { 
                audioref.current.currentTime = startTime;
                audioref.current.play();
            } else { 
                audioref.current.pause();
                audioref.current.currentTime = startTime;
                audioref.current.play();
            }
        }
    };

    // ============================================
    // SECTION 8: MAIN ACTION HANDLER
    // ============================================
    
    const handleMainAction = () => {
        switch (practiceMode) {
            case 'echoing':
                if (echoingPhase === 'idle') {
                    startEchoingMode();
                } else if (echoingPhase === 'recording') {
                    stopEchoingRecording(true);
                } else {
                    cancelEchoingMode();
                }
                break;
                
            case 'shadowing':
                if (!isShadowing && recordingStatus === 'inactive') {
                    startShadowing();
                } else if (recordingStatus === 'recording') {
                    stopShadowingRecording(true);
                }
                break;
                
            case 'manual':
                if (recordingStatus === 'inactive') {
                    startRecording(true);
                } else {
                    stopRecording(true);
                }
                break;
        }
    };

    // ============================================
    // SECTION 9: KEYBOARD SHORTCUT HANDLERS
    // ============================================
    
    const handlePlayPause = () => {
        if (audioref.current && segment && segment.hasOwnProperty("start")) {
            if (audioref.current.paused) {
                setFocus(segment);
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
                if (currentHandlerRef.current) {
                    audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
                }
                currentHandlerRef.current = handler;
                audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
                setIsPlayingSegment(true);
            } else {
                audioref.current.pause();
                setIsPlayingSegment(false);
            }
        }
    };

    const handleEscape = () => {
        cancelAllProcesses();
    };

    const cycleVisualizationView = () => {
        const views = ['pitch', 'intensity', 'music', 'colors', 'combined'];
        const currentIndex = views.indexOf(visualizationView);
        const nextIndex = (currentIndex + 1) % views.length;
        setVisualizationView(views[nextIndex]);
    };

    // ============================================
    // SECTION 10: VISUAL COMPONENTS
    // ============================================

    // Get button configuration based on mode and state
    const getButtonConfig = () => {
        if (practiceMode === 'echoing') {
            switch (echoingPhase) {
                case 'idle': 
                    return { 
                        text: 'Start Echoing', 
                        color: 'from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600',
                        icon: '🔄',
                        disabled: false
                    };
                case 'playing': 
                    return { 
                        text: 'Playing...', 
                        color: 'from-blue-400 to-indigo-400',
                        icon: '▶️',
                        disabled: true
                    };
                case 'paused': 
                    return { 
                        text: 'Get Ready...', 
                        color: 'from-amber-500 to-orange-500',
                        icon: '⏳',
                        disabled: true
                    };
                case 'recording': 
                    return { 
                        text: 'Stop Recording', 
                        color: 'from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600',
                        icon: '⏹️',
                        disabled: false
                    };
            }
        }
        
        if (practiceMode === 'shadowing') {
            if (isShadowing && recordingStatus === 'recording') {
                return { 
                    text: 'Stop Shadowing', 
                    color: 'from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600',
                    icon: '⏹️',
                    disabled: false
                };
            }
            return { 
                text: 'Shadow & Record', 
                color: 'from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600',
                icon: '🎭',
                disabled: !isgranted || recordingStatus !== 'inactive'
            };
        }
        
        if (practiceMode === 'manual') {
            if (recordingStatus === 'recording') {
                return { 
                    text: 'Stop Recording', 
                    color: 'from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600',
                    icon: '⏹️',
                    disabled: false
                };
            }
            return { 
                text: 'Start Recording', 
                color: 'from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600',
                icon: '⏺️',
                disabled: !isgranted
            };
        }
        
        // Default
        return { 
            text: 'Start', 
            color: 'from-blue-500 to-indigo-500',
            icon: '▶️',
            disabled: false
        };
    };

    const ProcessStatusIndicator = () => {
        const getStatusMessage = () => {
            if (recordingStatus === 'recording') {
                if (practiceMode === 'echoing') return 'Recording your echo...';
                if (practiceMode === 'shadowing') return 'Shadowing in progress...';
                return 'Recording...';
            }
            if (echoingPhase === 'playing') return 'Playing sentence...';
            if (echoingPhase === 'paused') return 'Get ready to repeat...';
            if (isPlayingSegment) return 'Playing...';
            return 'Ready';
        };

        return (
            <div className="flex items-center gap-3 mb-4 p-3 bg-white/50 rounded-xl border border-white/40">
                <div className={`w-3 h-3 rounded-full ${
                    recordingStatus === 'recording' ? 'bg-red-500' :
                    echoingPhase === 'playing' ? 'bg-blue-500' :
                    echoingPhase === 'paused' ? 'bg-amber-500 animate-pulse' :
                    echoingPhase === 'recording' ? 'bg-red-500' :
                    isShadowing ? 'bg-orange-500' :
                    isPlayingSegment ? 'bg-green-500' : 'bg-gray-400'
                } animate-pulse`}></div>
                <span className="text-sm font-medium text-gray-700">{getStatusMessage()}</span>
                {recordingStatus === 'recording' && practiceMode !== 'shadowing' && (
                    <span className="ml-auto text-sm font-bold text-blue-600">
                        {Math.round(recordingProgress)}%
                    </span>
                )}
            </div>
        );
    };
    //course
    const exerciseId = deriveExerciseId(subject, file);

const currentExercise =
  exerciseId && course?.exercises?.length
    ? course.exercises.find((e) => e.id === exerciseId) || null
    : null;
console.log(currentExercise, course, "coursecourse")
const hasExerciseHelp = !!currentExercise;

    // ============================================
    // SECTION 11: EFFECTS
    // ============================================
    
    useEffect(() => {
  const key = subject?.course_key;

  // No course_key => no help system
  if (!key) {
    setCourse(null);
    return;
  }

  let alive = true;


  loadCourse(key)
    .then((c) => {
      if (!alive) return;
      setCourse(c);
    })
    .catch((err) => {
      console.warn("loadCourse failed:", err);
      if (!alive) return;
      setCourse(null);
    })
    .finally(() => {
      if (!alive) return;
    
    });

  return () => {
    alive = false;
  };
}, [subject?.course_key]);



    useEffect(() => {
  if (!audio) return;
  audioRecord.current = new Audio(audio);
  return () => {
    if (audioRecord.current) {
      audioRecord.current.pause();
      audioRecord.current = null;
    }
  };
}, [audio]);

   useEffect(() => {
  if (!isGuest && subject?.language) fetchDailyGoal(subject.language);
}, [isGuest, subject?.language]);

    useEffect(() => {
        setSegments(null);
        setAssessment(null);
        setAudio(null);
        setRecordingStatus("inactive");
        setAudioChunks([]);
        setHasRecording(false);
        setLoading(false);
        setTranslation(null);
        setCurrentWord(0);
        setBroadcastTime(0);
        setIsPlayingSegment(false);
        setEditedSegments(null);
        setEditedSegment(null);
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        setIsCueActive(false);
        setRecordingProgress(0);
        setMaxRecordingTime(0);
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
        
        if (file && file.file) {
            getSegments({"subject": subject, "file": file.file});
        }
        
        if (audioRecordRef.current) {
            audioRecordRef.current.pause();
            audioRecordRef.current = null;
        }
    }, [file, subject]);

    useEffect(() => {
        if (navigator) {
            navigator.permissions
                .query({ name: "microphone" })
                .then(async function (result) {
                    if (result.state === "granted") {
                        if ("MediaRecorder" in window) {
                            try {
                                const streamData = await navigator.mediaDevices.getUserMedia({
                                    audio: true,
                                    video: false,
                                });
                                setIsGranted(true);
                                setStream(streamData);
                            } catch (err) {
                                alert(err.message);
                            }
                        } else {
                            alert("The MediaRecorder API is not supported in your browser.");
                        }
                   } else if (result.state === "prompt") {
                          console.log("Microphone permission prompt will be shown");


                    } else if (result.state === "denied") {
                        // Handle denied case
                    }
                });
        } else {
            console.log("navigator is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
     
        if (segments) {
            if (Object.keys(segment).length === 0) {
                setSegment(segments[0]);
            }
        };  
        setAssessment(null); 
        setRate(1); 
        setLoading(false); 
        setTranslation();
        setIsPlayingSegment(false);
        setCurrentWord(0);
        setIsShadowing(false);
        setShowFirstWordCue(false);
        setCuePulseCount(0);
        setIsCueActive(false);
        setRecordingProgress(0);
        setMaxRecordingTime(0);
        setEchoingPhase('idle');
        echoingPhaseRef.current = 'idle';
        setEchoingPulseCount(0);
        
        setPracticeMode(preservedMode);
        
        if (shadowingTimeout) {
            clearTimeout(shadowingTimeout);
            setShadowingTimeout(null);
        }
        
        if (echoingTimeout) {
            clearTimeout(echoingTimeout);
            setEchoingTimeout(null);
        }
        
        if (cueTimeouts.length > 0) {
            cueTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setCueTimeouts([]);
        }
        
        if (echoingTimeouts.length > 0) {
            echoingTimeouts.forEach(timeout => timeout && clearTimeout(timeout));
            setEchoingTimeouts([]);
        }
    }, [file, subject, segments, editedSegments]);

    

    useEffect(() => {
  if (!isGuest && subject?.language) fetchTodayActivity(subject.language);
}, [isGuest, subject?.language]);

    useEffect(() => {
       
        if (segment) {
            if ( segment.hasOwnProperty("end") && segment.hasOwnProperty("start")) { 
                if (segment.end - segment.start > 0) {
                    setDuration(segment.end - segment.start);
                }
            }
        }
    }, [segment]);
    
    useEffect(() => {
        let timer;
        let progressInterval;
        
        if (recordingStatus === 'recording') {
            const preAudioBuffer = Math.abs(SHADOWING_TIMING.RECORDING_START_OFFSET);
            const postAudioBuffer = SHADOWING_TIMING.POST_AUDIO_BUFFER;
            const extraTime = practiceMode === 'shadowing' ? (preAudioBuffer + postAudioBuffer) : 0;
            const totalDuration = 3 * duration * 1000 + extraTime;
            
            // Start progress tracking for all modes except shadowing
            if (practiceMode !== 'shadowing') {
                const startTime = Date.now();
                
                progressInterval = setInterval(() => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min((elapsed / totalDuration) * 100, 100);
                    setRecordingProgress(progress);
                    
                    if (progress >= 100) {
                        clearInterval(progressInterval);
                    }
                }, 100);
            }
            
            timer = setTimeout(() => {
                if (recordingStatus === 'recording') {
                    if (practiceMode === 'echoing') {
                        stopEchoingRecording(true);
                    } else if (practiceMode === 'shadowing') {
                        stopShadowingRecording(true);
                    } else {
                        stopRecording(true);
                    }
                }
                
                if (progressInterval) {
                    clearInterval(progressInterval);
                }
            }, totalDuration);

            if (recordRef.current && practiceMode !== 'shadowing') {
                try {
                    recordRef.current.animate(  
                        progress_frames,
                        { duration: totalDuration, fill: "forwards", iterations: 1 } 
                    );
                } catch (error) {
                    console.error("Error animating record ref:", error);
                }
            }
            
            if (pulseRef.current) {
                try {
                    pulseRef.current.animate(  
                        pulse_frames,
                        { duration: totalDuration, fill: "forwards", iterations: 100 } 
                    );
                } catch (error) {
                    console.error("Error animating pulse ref:", error);
                }
            }
        }
        
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
            if (progressInterval) {
                clearInterval(progressInterval);
            }
        };
    }, [recordingStatus, duration, practiceMode]);

    useEffect(() => {
        if (recordingStatus === "inactive") {
            setRecordingProgress(0);
        }
    }, [recordingStatus]);

    // Update echoingPhaseRef when echoingPhase changes
    useEffect(() => {
        echoingPhaseRef.current = echoingPhase;
    }, [echoingPhase]);

    // Keyboard Navigation Effect
  useEffect(() => {
    const handleKeyPress = (event) => {
        if (showExerciseHelp) return;
        if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
            return;
        }

        switch (event.key) {
            case 'ArrowLeft':
            case 'a':
            case 'A':
                event.preventDefault();
                handlePreviousSegment();
                break;

            case 'ArrowRight':
            case 'd':
            case 'D':
                event.preventDefault();
                handleNextSegment();
                break;

            case ' ':
                event.preventDefault();
                handlePlayPause();
                break;

            case 'r':
            case 'R':
                event.preventDefault();
                handleMainAction(); // R now works for ALL modes
                break;

            case 'p':
            case 'P':
                event.preventDefault();
                if (hasRecording && audio) {
                    Play_record();
                }
                break;

            case 'Escape':
                event.preventDefault();
                handleEscape();
                break;

            case '?':
                event.preventDefault();
                setShowKeyboardHelp(prev => !prev);
                break;

            case '1':
                event.preventDefault();
                setRate(1);
                if (audioref.current) audioref.current.playbackRate = 1;
                break;

            case '2':
                event.preventDefault();
                setRate(0.5);
                if (audioref.current) audioref.current.playbackRate = 0.5;
                break;

            case '3':
                event.preventDefault();
                setRate(0.25);
                if (audioref.current) audioref.current.playbackRate = 0.25;
                break;

            case 'm':
            case 'M':
                event.preventDefault();
                setShowIntonationVisualization(prev => !prev);
                break;

            case 'v':
            case 'V':
                event.preventDefault();
                cycleVisualizationView();
                break;

            case 't':
            case 'T':
                event.preventDefault();
                // Cycle through practice modes: echoing -> shadowing -> manual -> echoing
                const modes = ['echoing', 'shadowing', 'manual'];
                const currentIndex = modes.indexOf(practiceMode);
                const nextIndex = (currentIndex + 1) % modes.length;
                cancelAllProcesses();
                setPracticeMode(modes[nextIndex]);
                setPreservedMode(modes[nextIndex]);
                break;
        }
    };

    keyboardListenerRef.current = handleKeyPress;
    document.addEventListener('keydown', handleKeyPress);
    return () => {
        document.removeEventListener('keydown', handleKeyPress);
    };
}, [segment, segments, isgranted, recordingStatus, hasRecording, audio, visualizationView, activeTab, handler, practiceMode, echoingPhase, showExerciseHelp]);
    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.hamburger-button')) {
                setMobileMenuOpen(false);
            }
            if (showKeyboardHelp && !event.target.closest('.keyboard-help') && !event.target.closest('.keyboard-help-button')) {
                setShowKeyboardHelp(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [mobileMenuOpen, showKeyboardHelp]);

    // Cleanup timeouts on unmount
    useEffect(() => {
        return () => {
            cancelAllProcesses();
            
            if (audioRecordRef.current) {
                audioRecordRef.current.pause();
                audioRecordRef.current = null;
            }
            
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                try {
                    mediaRecorderRef.current.stop();
                } catch (error) {
                    console.error("Error cleaning up media recorder:", error);
                }
            }
            
            if (audioref.current) {
                if (currentHandlerRef.current) {
                    audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
                }
                if (currentHandlerRefEd.current) {
                    audioref.current.removeEventListener('timeupdate', currentHandlerRefEd.current);
                }
            }
            
            if (keyboardListenerRef.current) {
                document.removeEventListener('keydown', keyboardListenerRef.current);
            }
        };
    }, []);

    // ============================================
    // SECTION 12: MAIN RENDER
    // ============================================
    return (
     <div className="flex flex-col xl:flex-row h-[100dvh] w-full overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">

            {/* Keyboard Help Modal */}
            <KeyboardHelpModal 
                showKeyboardHelp={showKeyboardHelp} 
                setShowKeyboardHelp={setShowKeyboardHelp} 
            />
            
           

            {/* Desktop Sidebar */}
          <div
  className={[
    "hidden xl:flex flex-none flex-col gap-4 transition-all duration-300 h-full min-h-0 overflow-y-auto p-4",
    "bg-white/20 backdrop-blur-sm border-r border-white/30",
    sidebarCollapsed ? "xl:w-20" : "xl:w-96",
  ].join(" ")}
>

                
                {/* Translation Panel - Desktop */}
                {translation && (
                    <div className={`bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0 ${sidebarCollapsed ? 'xl:hidden' : ''}`}>
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                                <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center text-white text-sm">
                                    🌐
                                </div>
                                Translation
                            </h3>
                            <button 
                                onClick={()=>{setTranslation()}} 
                                className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200 border border-white/40"
                            >
                                <span className="text-gray-500 text-lg">×</span>
                            </button>
                        </div>
                        {translation.translation[0]?.hasOwnProperty("normalizedSource") ?
                            <div className='text-left space-y-3'>
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-3 border border-blue-200/50">
                                    <p className='font-semibold text-gray-800'>
                                        {translation.translation[0].normalizedSource} 
                                    </p>
                                    <p className='text-xs text-gray-500 mt-1'>normalized form</p>
                                </div>
                                <ul className='space-y-2 text-sm'>
                                    {translation.translation[0].translations.map((item, i)=>{
                                        return(
                                            <li key={i} className='flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40'>
                                                <span className='font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs'>{i+1}</span>
                                                <span className="text-gray-700 flex-1">{item.displayTarget}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        : 
                        (translation.translation === "missing translation") ? 
                            <div className='text-center text-gray-500 py-4 bg-white/50 rounded-xl border border-white/40'>
                                <div className="text-2xl mb-2">🔍</div>
                                <p>Translation not available</p>
                            </div>
                        :
                            <div className='text-left space-y-3'>
                                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-3 border border-green-200/50">
                                    <p className='font-semibold text-gray-800'>
                                        {translation.word}
                                    </p>
                                </div>
                                <ul className='space-y-2 text-sm'>
                                    {translation.translation[0].translations.map((item, i)=>{
                                        return(
                                            <li key={i} className='flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40'>
                                                <span className='font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs'>{i+1}</span>
                                                <span className="text-gray-700 flex-1">{item.text}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        }
                    </div>
                )}
{!isGuest && (
     <div className="flex justify-center">
  <ProgressPill 
    language={subject?.language || "en"} // Ensure this has a value
  showLanguageFlag={true}
    doneSeconds={todaySeconds}
    goalSeconds={goalSeconds}
    onClick={() => setShowProgressModal(true)}
    collapsed={sidebarCollapsed}
  />
  </div>
)}
                {/* Desktop Sidebar Content - Practice Mode Selection */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0">
                    {/* Daily Progress Pill */}


                    
                    <div className="flex items-center justify-between mb-4">
                        <h2 className={`font-bold text-gray-800 text-lg flex items-center gap-2 ${sidebarCollapsed ? 'xl:hidden' : ''}`}>
                            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center text-white text-sm">
                                🎵
                            </div>
                            Practice Mode
                        </h2>
                        <button
                            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                            className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200 hidden xl:block border border-white/40 shadow-sm"
                            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                        >
                            {sidebarCollapsed ? 
                                <BsArrowsExpand className="text-gray-500" /> : 
                                <BsArrowsCollapse className="text-gray-500" />
                            }
                        </button>
                    </div>

                    {/* Practice Mode Selection - Moved from CompactModeSelector */}
                    <div className={`space-y-3 ${sidebarCollapsed ? 'xl:hidden' : ''}`}>
                        
                        {[
                            { key: 'echoing', label: 'Echo Mode', icon: '🔄', desc: 'Listen → Repeat', color: 'from-blue-500 to-indigo-500' },
                            { key: 'shadowing', label: 'Shadow Mode', icon: '🎭', desc: 'Speak with narrator', color: 'from-amber-500 to-orange-500' },
                            { key: 'manual', label: 'Manual Mode', icon: '🎮', desc: 'Manual control', color: 'from-green-500 to-emerald-500' }
                        ].map(({ key, label, icon, desc, color }) => (
                            <button
                                key={key}
                                onClick={() => {
                                    cancelAllProcesses();
                                    setPracticeMode(key);
                                    setPreservedMode(key);
                                }}
                                className={`w-full text-left py-3 px-4 rounded-xl transition-all duration-300 font-medium text-sm flex items-center justify-between group border ${
                                    practiceMode === key
                                        ? `bg-gradient-to-r ${color} text-white shadow-lg border-transparent`
                                        : "bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md"
                                } ${(echoingPhase !== 'idle' || recordingStatus === 'recording') && practiceMode !== key ? 'opacity-50 cursor-not-allowed' : ''}`}
                                disabled={(echoingPhase !== 'idle' || recordingStatus === 'recording') && practiceMode !== key}
                                title={desc}
                            >
                                <div className="flex items-center gap-3">
                                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm transition-all duration-300 ${
                                        practiceMode === key ? 'bg-white/20' : 'bg-gray-100 group-hover:bg-gray-200'
                                    }`}>
                                        {icon}
                                    </div>
                                    <div className="text-left">
                                        <div className="font-medium">{label}</div>
                                        <div className={`text-xs ${practiceMode === key ? 'text-white/80' : 'text-gray-500'}`}>
                                            {desc}
                                        </div>
                                    </div>
                                </div>
                                {practiceMode === key && (
                                    <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Visualization Controls - Desktop */}
                <div className={`bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0 ${sidebarCollapsed ? 'xl:hidden' : ''}`}>
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white text-sm">
                                📊
                            </div>
                            Visualization
                        </h3>
                        <div className="flex items-center gap-2">
                            <span className={`text-sm font-medium ${showIntonationVisualization ? 'text-green-600' : 'text-gray-400'}`}>
                                {showIntonationVisualization ? 'ON' : 'OFF'}
                            </span>
                            <button
                                onClick={() => setShowIntonationVisualization(!showIntonationVisualization)}
                                className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
                                    showIntonationVisualization 
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-500 shadow-lg shadow-green-500/25' 
                                        : 'bg-gray-300/60'
                                }`}
                            >
                                <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-all duration-300 ${
                                        showIntonationVisualization ? 'translate-x-6' : 'translate-x-1'
                                    }`}
                                />
                            </button>
                        </div>
                    </div>

                    {showIntonationVisualization && (
                        <div className="space-y-4">
                           
                            <div className="grid grid-cols-2 xl:grid-cols-1 gap-3">
                                {[
                                    { key: 'pitch', icon: '📈', label: 'Pitch', color: 'from-blue-500 to-cyan-500' },
                                    { key: 'intensity', icon: '🔊', label: 'Intensity', color: 'from-orange-500 to-red-500' },
                                    { key: 'music', icon: '🎵', label: 'Music Notes', color: 'from-purple-500 to-pink-500' },
                                    { key: 'colors', icon: '🎨', label: 'Color Words', color: 'from-green-500 to-emerald-500' },
                                    { key: 'combined', icon: '🌀', label: 'Combined', color: 'from-indigo-500 to-purple-500' }
                                ].map(({ key, icon, label, color }) => (
                                    <button
                                        key={key}
                                        onClick={() => setVisualizationView(key)}
                                        className={`p-4 rounded-xl transition-all duration-300 flex items-center gap-3 group border ${
                                            visualizationView === key 
                                                ? `bg-gradient-to-r ${color} text-white shadow-lg border-transparent transform scale-105` 
                                                : "bg-white/60 text-gray-600 hover:bg-white/80 border-white/40 hover:border-white/60 hover:shadow-md hover:transform hover:scale-105"
                                        }`}
                                    >
                                        <span className={`text-lg transition-all duration-300 ${
                                            visualizationView === key ? 'scale-110' : 'group-hover:scale-110'
                                        }`}>
                                            {icon}
                                        </span>
                                        <span className="font-medium text-sm">{label}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Main Content Panel */}
         <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">
                  {/* Mobile Header */}
            <MobileHeader 
            language={subject?.language}
  mobileMenuOpen={mobileMenuOpen}
  setMobileMenuOpen={setMobileMenuOpen}
  setShowKeyboardHelp={setShowKeyboardHelp}
  showIntonationVisualization={showIntonationVisualization}
  setShowIntonationVisualization={setShowIntonationVisualization}
  visualizationView={visualizationView}
  setVisualizationView={setVisualizationView}
  practiceMode={practiceMode}
  setPracticeMode={setPracticeMode}
  cancelAllProcesses={cancelAllProcesses}
  setPreservedMode={setPreservedMode}
 isGuest={isGuest}
  todaySeconds={todaySeconds}
  goalSeconds={goalSeconds}
  setShowProgressModal={setShowProgressModal}
/>               
                {/* Keyboard Help Floating Button - Desktop */}
                {!isMobile && (
  <div className="fixed bottom-6 right-6 z-30">
                    <button
                        onClick={() => setShowKeyboardHelp(true)}
                        className="keyboard-help-button group p-3 bg-white/80 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg shadow-blue-500/5 hover:bg-white transition-all duration-300"
                        title="Keyboard Shortcuts (Press ?)"
                    >
                        <MdKeyboard className="text-gray-600 group-hover:text-blue-600 text-xl transition-colors" />
                    </button>
                </div>) }

                {/* Content Area */}
<div className="flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden p-4 xl:p-6 pb-6">

                    {/* Hidden Audio Element - Required for playback */}
                    <audio 
                        preload="auto" 
                        ref={audioref} 
                        className='hidden'  
                        src={fullaudio} 
                        onTimeUpdate={timeUpdate}  
                        type="mp3/audio"
                    />
                    
                    {/* Sentence Practice Section - Always active now */}
                   

                    {segments && !editedSegments && (
                        <div className="flex flex-col gap-6">
                            {/* Process Status Indicator */}
                            
                            
                           {/* Sentence Display Block */}
<div className='bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5'>
   
       {/* Navigation Header */}
                                <div className="flex items-center justify-between mb-6">
                                     <button 
                                            onClick={handlePreviousSegment}
                                            disabled={segment.id === 0}
                                            className={`p-3 rounded-xl transition-all duration-300 flex items-center gap-2 ${
                                                segment.id === 0
                                                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                    : 'bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md'
                                            }`}
                                        >
                                            <span className="text-lg">←</span>
                                            <span className="hidden sm:inline text-sm font-medium">Previous</span>
                                        </button>
                                   <div className="flex items-center gap-3">
  <h3 className="font-bold text-gray-800">
    Sentence {segment.id + 1} of {segments.length}
  </h3>

  {hasExerciseHelp && (
    <button
      onClick={() => setShowExerciseHelp(true)}
      className="px-3 py-2 rounded-xl bg-white/60 text-gray-700 hover:bg-white border border-white/40 hover:border-white/60 hover:shadow-md transition-all duration-300 text-sm font-medium flex items-center gap-2"
      title={`Exercise help (${exerciseId})`}
    >
      <span>❔</span>
      <span className="hidden sm:inline">Exercise help</span>
    </button>
  )}
</div>

                                    
                                       
                                        
                                        <button 
                                            onClick={handleNextSegment}
                                            disabled={segment.id >= segments.length - 1}
                                            className={`p-3 rounded-xl transition-all duration-300 flex items-center gap-2 ${
                                                segment.id >= segments.length - 1
                                                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                    : 'bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md'
                                            }`}
                                        >
                                            <span className="hidden sm:inline text-sm font-medium">Next</span>
                                            <span className="text-lg">→</span>
                                        </button>
                                    
                                </div>
    {/* RESERVED SPACE FOR CUES - Fixed height container */}
    <div className="h-10 mb-2 relative">
        {/* SHADOWING VISUAL CUE - Positioned within reserved space */}
        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-200 ${
            practiceMode === 'shadowing' && (isShadowing || recordingStatus === "recording") 
                ? 'opacity-100' 
                : 'opacity-0'
        }`}>
            <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-amber-600">
                    {isCueActive ? 'Get ready...' : 'Shadowing...'}
                </span>
                
                {isCueActive && (
                    <div className="flex items-center gap-1">
                        <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                            cuePulseCount >= 1 ? 'bg-amber-500' : 'bg-gray-300'
                        }`}></div>
                        <div className="w-3 h-0.5 bg-gray-300"></div>
                        <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                            cuePulseCount >= 2 ? 'bg-orange-500' : 'bg-gray-300'
                        }`}></div>
                        <div className="w-3 h-0.5 bg-gray-300"></div>
                        <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                            cuePulseCount >= 3 ? 'bg-green-500 animate-pulse' : 'bg-gray-300'
                        }`}></div>
                    </div>
                )}
            </div>
        </div>

        
        
        {/* ECHOING VISUAL CUE - Positioned within reserved space */}
        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-200 ${
            practiceMode === 'echoing' && echoingPhase === 'paused' 
                ? 'opacity-100' 
                : 'opacity-0'
        }`}>
            <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-blue-600">
                    Get ready...
                </span>
                
                <div className="flex items-center gap-1">
                    <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                        echoingPulseCount >= 1 ? 'bg-blue-500' : 'bg-gray-300'
                    }`}></div>
                    <div className="w-3 h-0.5 bg-gray-300"></div>
                    <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                        echoingPulseCount >= 2 ? 'bg-indigo-500' : 'bg-gray-300'
                    }`}></div>
                    <div className="w-3 h-0.5 bg-gray-300"></div>
                    <div className={`w-2 h-2 rounded-full transition-all duration-200 ${
                        echoingPulseCount >= 3 ? 'bg-green-500 animate-pulse' : 'bg-gray-300'
                    }`}></div>
                </div>
            </div>
        </div>
    </div>
    
    
    {/* Sentence Words Display - This now has consistent spacing from the header */}
  <div className="min-h-[80px] p-4 bg-gradient-to-r from-blue-50/50 to-indigo-50/50 rounded-2xl border border-blue-200/30">
  <div className="flex flex-wrap gap-2 justify-center items-center">
    {segment?.words?.map((item, i) => {
      const isActive = currentWord === i;

      // Special styling ONLY for shadowing cue on first word
      const isShadowCueWord =
        practiceMode === "shadowing" &&
        isCueActive &&
        cuePulseCount >= 1 &&
        i === 0;

      // Base click behavior:
      // - shadowing: play word on click (keeps your existing behavior)
      // - echoing/manual: tap opens word menu (play/translate) instead of immediately playing
      const onWordClick =
        practiceMode === "shadowing"
          ? () => handleWordPlay(i, item)
          : (e) => openWordMenu(e, item.text, i);

      // Coloring by mode (and cue)
      const activeClass =
        practiceMode === "shadowing"
          ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 transform scale-105"
          : practiceMode === "echoing"
          ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg shadow-blue-500/25 transform scale-105"
          : "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-500/25 transform scale-105";

      const idleClass =
        "text-gray-800 bg-white/80 hover:bg-white border border-white/40 hover:border-white/60 hover:shadow-md";

      // Optional subtle mode hint (no extra icons per word)
      const ringClass =
        practiceMode === "manual"
          ? "ring-1 ring-emerald-200/60"
          : practiceMode === "echoing"
          ? "ring-1 ring-indigo-200/60"
          : "ring-1 ring-orange-200/60";

      return (
        <span
          key={i}
          onClick={onWordClick}
          className={[
            "text-lg font-medium px-3 py-2 rounded-xl transition-all duration-300 cursor-pointer relative overflow-hidden",
            ringClass,
            isActive ? activeClass : idleClass,
          ].join(" ")}
          title={
            practiceMode === "shadowing"
              ? "Tap to play from here"
              : "Tap for Play / Translate"
          }
        >
          {item.text}

          {/* Shadowing cue pulse (first word only) */}
          {isShadowCueWord && (
            <div className="absolute inset-0 bg-white/20 animate-ping rounded-xl" />
          )}
        </span>
      );
    })}
  </div>
</div>

</div>
                            
                            {/* Central Control Panel */}
                            <div className='p-4 xl:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5'>
                                
                                {/* Main Control Center */}
                                <div className="flex flex-col items-center space-y-6">
                                    {/* Speed Controls */}
                                    <div className="flex items-center space-x-3">
                                        <span className="text-sm text-gray-600 font-medium">Playback Speed:</span>
                                        <div className="flex space-x-1 bg-white/60 rounded-lg p-1">
                                            {[0.25, 0.5, 1].map((speed) => (
                                                <button
                                                    key={speed}
                                                    onClick={() => {
                                                        setRate(speed);
                                                        if (audioref.current) audioref.current.playbackRate = speed;
                                                    }}
                                                    className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
                                                        rate === speed
                                                            ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow'
                                                            : 'text-gray-600 hover:bg-white'
                                                    }`}
                                                >
                                                    {speed}x
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    
<div className="w-full max-w-md">
    {!isgranted ? (
        <button
            onClick={getMicrophonePermission}
            className="w-full py-4 px-6 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white rounded-xl transition-all duration-300 font-medium shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40 flex items-center justify-center gap-3"
        >
            <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                <span className="text-lg">🎤</span>
            </div>
            <span className="font-medium text-lg">Enable Microphone</span>
        </button>
    ) : practiceMode === 'manual' ? (
        <div className="flex flex-col sm:flex-row gap-4">
            <button
                onClick={handlePlayPause}
                disabled={recordingStatus === 'recording'}
                className={`flex-1 py-4 px-4 rounded-xl transition-all duration-300 font-medium shadow-lg flex items-center justify-center gap-2 ${
                    recordingStatus === 'recording'
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : isPlayingSegment
                            ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white hover:from-amber-600 hover:to-orange-600'
                            : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white'
                }`}
            >
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                    <span className="text-lg">
                        {isPlayingSegment ? '⏹️' : '▶️'}
                    </span>
                </div>
                <span className="font-medium">
                    {isPlayingSegment ? 'Stop' : 'Play'}
                </span>
            </button>
            
            <div className="relative flex-1">
                <button
                    onClick={handleMainAction}
                    disabled={!isgranted}
                    className={`w-full py-4 px-4 rounded-xl transition-all duration-300 font-medium shadow-lg flex items-center justify-center gap-2 relative overflow-hidden ${
                        recordingStatus === "recording"
                            ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white hover:from-red-600 hover:to-orange-600'
                            : 'bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white'
                    }`}
                >
                    {recordingStatus === 'recording' && (
                        <div className="absolute inset-0 bg-white/10">
                            <div 
                                className="absolute inset-y-0 left-0 bg-gradient-to-r from-white/15 to-white/5 transition-all duration-300"
                                style={{ width: `${recordingProgress}%` }}
                            />
                        </div>
                    )}
                    
                    {recordingStatus === 'recording' && (
                        <div className="absolute bottom-0 left-0 w-full h-0.5 bg-white/10 rounded-b-xl overflow-hidden">
                            <div 
                                className="h-full bg-gradient-to-r from-white/40 to-white/30 transition-all duration-300 rounded-b-xl"
                                style={{ width: `${recordingProgress}%` }}
                            />
                        </div>
                    )}
                    
                    {recordingStatus === 'recording' && (
                        <div className="absolute top-2 right-2">
                            <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center animate-pulse">
                                <div className="w-2 h-2 bg-red-300 rounded-full"></div>
                            </div>
                        </div>
                    )}
                    
                    <div className="relative z-10 w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                        <span className="text-lg">
                            {recordingStatus === 'recording' ? '⏹️' : '⏺️'}
                        </span>
                    </div>
                    <span className="relative z-10 font-medium">
                        {recordingStatus === 'recording' ? 'Stop' : 'Record'}
                    </span>
                    
                    {recordingStatus === 'recording' && (
                        <span className="relative z-10 ml-1 text-sm font-bold text-white/90">
                            {Math.round(recordingProgress)}%
                        </span>
                    )}
                </button>
            </div>
        </div>
    ) : (
        <div className="relative">
            <button
                onClick={handleMainAction}
                disabled={practiceMode === 'echoing' && echoingPhase === 'playing' ? false : getButtonConfig().disabled}
                className={`w-full py-4 px-6 rounded-xl transition-all duration-300 font-medium shadow-lg flex items-center justify-center gap-3 relative overflow-hidden ${
                    practiceMode === 'echoing' && echoingPhase === 'playing' 
                        ? 'bg-gradient-to-r from-blue-400 to-indigo-400 text-white cursor-pointer hover:from-blue-500 hover:to-indigo-500' 
                        : getButtonConfig().disabled
                            ? 'bg-gradient-to-r from-gray-300 to-gray-400 text-gray-500 cursor-not-allowed'
                            : `bg-gradient-to-r ${getButtonConfig().color} text-white hover:shadow-xl`
                }`}
            >
                {practiceMode === 'echoing' && recordingStatus === 'recording' && (
                    <div className="absolute inset-0 bg-white/10">
                        <div 
                            className="absolute inset-y-0 left-0 bg-gradient-to-r from-white/15 to-white/5 transition-all duration-300"
                            style={{ width: `${recordingProgress}%` }}
                        />
                    </div>
                )}
                
                {practiceMode === 'echoing' && recordingStatus === 'recording' && (
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-white/10 rounded-b-xl overflow-hidden">
                        <div 
                            className="h-full bg-gradient-to-r from-white/40 to-white/30 transition-all duration-300 rounded-b-xl"
                            style={{ width: `${recordingProgress}%` }}
                        />
                    </div>
                )}
                
                {practiceMode === 'echoing' && (echoingPhase !== 'idle' || recordingStatus === 'recording') && (
                    <div className="absolute top-2 right-2">
                        <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center">
                            <span className="text-xs">✕</span>
                        </div>
                    </div>
                )}
                
                <div className="relative z-10 w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                    <span className="text-lg">{getButtonConfig().icon}</span>
                </div>
                <span className="relative z-10 font-medium text-lg">
                    {practiceMode === 'echoing' ? (
                        echoingPhase === 'idle' ? 'Start Echoing' :
                        echoingPhase === 'playing' ? 'Cancel Playing' :
                        echoingPhase === 'paused' ? 'Cancel Countdown' :
                        echoingPhase === 'recording' ? 'Stop Recording' : 'Echoing'
                    ) : getButtonConfig().text}
                </span>
                
                {practiceMode === 'echoing' && recordingStatus === 'recording' && (
                    <span className="relative z-10 ml-2 text-sm font-bold text-white/90">
                        {Math.round(recordingProgress)}%
                    </span>
                )}
            </button>
            
            
        </div>
    )}
</div>
                                    
                                    
                                </div>
                                
                                
                            </div>
                            
                            {/* No User Recording Yet */}
                            {!assessment && segment.hasOwnProperty('words') && (
                                <div className="p-8 text-center bg-white/50 rounded-2xl border border-white/40">
                                    {loading ? (
                                        <div className="flex flex-col items-center">
                                            <PacmanLoader
                                                loading={loading}
                                                color="#3B82F6"
                                                size={16}
                                                aria-label="Analyzing recording"
                                            />
                                            <p className="text-gray-600 font-medium mt-3">Analyzing your recording...</p>
                                        </div>
                                    ) : recordingStatus === 'recording' ? (
                                        <div className="flex flex-col items-center">
                                            <div className="text-3xl mb-3 animate-pulse">
                                                {practiceMode === 'shadowing' ? '🎭' : 
                                                 practiceMode === 'echoing' ? '🔄' : 
                                                 '🎤'}
                                            </div>
                                            <p className="text-gray-600 font-medium mb-1">
                                                {practiceMode === 'shadowing' ? 'Shadowing in progress...' : 
                                                 practiceMode === 'echoing' ? 'Echoing in progress...' : 
                                                 'Recording in progress...'}
                                            </p>
                                            <p className="text-gray-500 text-sm">Speak the sentence above</p>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col items-center">
                                            <div className="text-3xl mb-1">🎤</div>
                                            <p className="text-gray-600 font-medium mb-1">Record to see comparison</p>
                                        
                                        </div>
                                    )}
                                </div>
                            )}
                            
                            {/* Combined Intonation Visualization Block */}
                            {showIntonationVisualization && (
                                <div className='bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5 overflow-hidden'>
                                    <div className="flex flex-col">
                                        {/* Narrator Intonation - Compact */}
                                        {segment.hasOwnProperty('words') && (
                                            <div className="p-4 border-b border-white/20">
                                                <div className="flex items-center gap-2 mb-3">
                                                    <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center text-white text-xs">
                                                        🎭
                                                    </div>
                                                    <h4 className="font-semibold text-gray-700">Narrator</h4>
                                                    <span className="text-xs text-gray-500 bg-blue-100 px-2 py-0.5 rounded-full">Reference</span>
                                                    <span className="text-xs text-gray-400 ml-auto hidden sm:inline">Press V to cycle views</span>
                                                </div>
                                                <div className="min-h-[200px]">
                                                    <NarratorIntonation 
                                                        subject={subject} 
                                                        file={file} 
                                                        segment={segment} 
                                                        broadcastTime={broadcastTime} 
                                                        view={visualizationView}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {/* User Intonation - Compact */}
                                        {assessment && (
                                            <div className="p-4">
                                               
                                                <div className="flex items-center gap-2 mb-3">
                                                    <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center text-white text-xs">
                                                        🎙️
                                                    </div>
                                                    <h4 className="font-semibold text-gray-700">Your Voice</h4>
                                                    <span className="text-xs text-gray-500 bg-green-100 px-2 py-0.5 rounded-full">Your Recording</span>
                                                </div>
                                                <div className="min-h-[200px]">
                                                    <IntonationFeedbackDisplay 
                                                        assessment={assessment}
                                                        segment={segment}
                                                        view={visualizationView}
                                                        isAdmin={auth?.role === "ADMIN" ? true : false}
                                                    /> 
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* AI Assessment Block */}
                            {assessment && (
                                <div className='p-4 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 backdrop-blur-sm rounded-2xl border border-purple-200/50 shadow-lg shadow-purple-500/5'>
                                    {auth?.username === 'guest' && (
                                        <div className='text-red-500 text-sm font-semibold text-center mb-3 p-3 bg-red-50 rounded-lg border border-red-200/50'>
                                            AI assessment for registered users only
                                        </div>
                                    )}
                                    
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="p-2 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl shadow-lg shadow-purple-500/25">
                                            <span className="text-white text-lg">🤖</span>
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-gray-800">AI Assessment</h3>
                                            <p className="text-gray-600 text-xs">Detailed feedback</p>
                                        </div>
                                    </div>
                                    
                                    <AIAssessmentDisplay 
                                        assessment={assessment}
                                        segment={segment}
                                    />
                                </div>
                            )}
                            
                            {/* Edit Button */}
                            {auth?.role === "ADMIN" && !editedSegments && segments && (
                                <div className='flex justify-center'>
                                    <button 
                                        className='px-6 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white rounded-lg transition-all duration-300 font-medium shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                        onClick={() => {
                                            const mysegments = [...segments]; 
                                            const currentSegment = segments.find(s => s.id === segment.id) || segments[0];
                                            const mysegment = {...currentSegment}; 
                                            setEditedSegments(mysegments); 
                                            setEditedSegment(mysegment);
                                        }}
                                    >
                                        Edit Segments
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Segment Editor Component */}
                    {editedSegments && (
                        <SegmentEditor
                            segments={segments}
                            editedSegments={editedSegments}
                            setEditedSegments={setEditedSegments}
                            editedSegment={editedSegment}
                            setEditedSegment={setEditedSegment}
                            audioref={audioref}
                            subject={subject}
                            file={file}
                            onSave={handleSaveEditedSegments}
                            onCancel={() => {
                                setEditedSegments(null);
                                setEditedSegment(null);
                            }}
                        />
                    )}
                </div>
                 <div className="h-24 xl:h-32 shrink-0" />
            </div>

            {/* Mobile Translation Modal */}
            {showTranslationModal && translation && (
                <div className="fixed inset-0 z-50 xl:hidden">
                    {/* Backdrop */}
                    <div 
                        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                        onClick={() => setShowTranslationModal(false)}
                    />
                    
                    {/* Modal Content */}
                    <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm rounded-t-3xl border-t border-white/30 shadow-2xl max-h-[85vh] overflow-hidden animate-in slide-in-from-bottom-1 duration-300">
                        <div className="p-6 max-h-[85vh] overflow-y-auto">
                            {/* Header */}
                            <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                                <h2 className="font-bold text-gray-800 text-xl flex items-center gap-3">
                                    <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center text-white">
                                        🌐
                                    </div>
                                    Translation
                                </h2>
                                <button
                                    onClick={() => setShowTranslationModal(false)}
                                    className="p-2 hover:bg-gray-100 rounded-xl transition-all duration-200"
                                >
                                    <span className="text-gray-500 text-2xl">×</span>
                                </button>
                            </div>

                            {/* Translation Content */}
                            <div className="space-y-4">
                                {translation.translation[0]?.hasOwnProperty("normalizedSource") ? (
                                    <div className='space-y-4'>
                                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-200/50">
                                            <p className='font-semibold text-gray-800 text-lg'>
                                                {translation.translation[0].normalizedSource} 
                                            </p>
                                            <p className='text-xs text-gray-500 mt-1'>Normalized form</p>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                                <span className="text-amber-500">📖</span>
                                                Translations
                                            </h4>
                                            <ul className='space-y-3'>
                                                {translation.translation[0].translations.map((item, i) => (
                                                    <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                        <span className='font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                        <span className="text-gray-700 flex-1">{item.displayTarget}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                ) : (translation.translation === "missing translation") ? (
                                    <div className="text-center py-8 bg-white/50 rounded-xl border border-gray-200">
                                        <div className="text-4xl mb-3 opacity-50">🔍</div>
                                        <p className="text-gray-600 font-medium">Translation not available</p>
                                        <p className="text-gray-500 text-sm mt-1">Try a different word</p>
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200/50">
                                            <p className='font-semibold text-gray-800 text-lg'>
                                                {translation.word}
                                            </p>
                                            <p className='text-xs text-gray-500 mt-1'>Word to translate</p>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                                <span className="text-green-500">📚</span>
                                                Translations
                                            </h4>
                                            <ul className='space-y-3'>
                                                {translation.translation[0].translations.map((item, i) => (
                                                    <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                        <span className='font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                        <span className="text-gray-700 flex-1">{item.text}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Close Button */}
                            <div className="mt-8 pt-4 border-t border-gray-200">
                                <button
                                    onClick={() => setShowTranslationModal(false)}
                                    className="w-full py-3 px-4 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-xl font-medium transition-all duration-300 hover:shadow-lg"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                     
                </div>
              

            )}


            {wordMenu && (
  <>
    {/* backdrop to close */}
    <div
      className="fixed inset-0 z-30"
      onClick={closeWordMenu}
    />

    {/* bubble */}
    <div
      className="fixed z-50"
      style={{
        left: Math.min(wordMenu.rect.left, window.innerWidth - 220),
        top: wordMenu.rect.top + wordMenu.rect.height + 8,
      }}
    >
      <div className="bg-white/95 backdrop-blur-sm border border-white/40 shadow-lg rounded-xl px-2 py-2 flex items-center gap-2">
        <button
          onClick={() => {
            handleWordPlay(wordMenu.i, segment.words[wordMenu.i]);
            closeWordMenu();
          }}
          className="px-3 py-2 rounded-lg bg-white/60 hover:bg-white border border-white/40 text-sm font-medium"
        >
          ▶ Play
        </button>

        <button
          onClick={() => {
            handleWordClick(wordMenu.text);
            // on mobile you already open modal in handleWordClick
            closeWordMenu();
          }}
          className="px-3 py-2 rounded-lg bg-white/60 hover:bg-white border border-white/40 text-sm font-medium"
        >
          🌐 Translate
        </button>
      </div>
    </div>
  </>
)}

           {!isGuest && (
 <ProgressModal
  open={showProgressModal}
  onClose={() => setShowProgressModal(false)}
  doneSeconds={todaySeconds}
  goalSeconds={goalSeconds}
  minGoalSeconds={MIN_GOAL_SECONDS}   
  onGoalMinus={() => updateDailyGoal(goalSeconds - STEP_SECONDS)} // optional: simpler
  onGoalPlus={() => updateDailyGoal(goalSeconds + STEP_SECONDS)}
/>

)}
<ExerciseHelpModal
  open={showExerciseHelp}
  onClose={() => setShowExerciseHelp(false)}
  exercise={currentExercise}
  course={course}
/>


        </div>
    );
    
};

export default SnapsWise;